import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { VideoCameraIcon } from '@heroicons/react/24/outline';

/**
 * Fluid 16:9 thumbnail. The box reserves its height before the image loads
 * (no layout shift); the image covers it. A missing URL or a failed load
 * shows a neutral camera tile instead. Decorative (empty alt): the title is
 * always shown next to it.
 */
VideoThumbnail.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

export default function VideoThumbnail(props) {
  const { url, className, children } = props;
  const [failedUrl, setFailedUrl] = useState(null);
  const showImage = Boolean(url) && failedUrl !== url;

  return (
    <div className={classNames('relative w-full [aspect-ratio:16/9] rounded-[10px] bg-cs-gray-200', className)}>
      {showImage ? (
        <img
          src={url}
          alt=""
          loading="lazy"
          onError={() => setFailedUrl(url)}
          className="absolute inset-0 size-full object-cover rounded-[10px]"
          data-testid="video-thumbnail-image"
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center" data-testid="video-thumbnail-fallback">
          <VideoCameraIcon className="size-10 text-cs-gray-500" aria-hidden="true" />
        </div>
      )}
      {children}
    </div>
  );
}
